import { Component } from 'preact'
import { extractRenderPropsChildren } from '../../../libs/renderProps'
import InputGroup from '../../ui-components/InputGroup'
import { BaseFilterSelectorBuilderData, FilterSelectorProps } from './interfaces'
import { FilterSelector } from '@insided/deprecated-control/overview/filters/FiltersMenu'

interface RadioInputFilterSelectorItem {
    id: string | number
    name: string
    value: string
    type?: string
}

interface CommonProps {
    items: RadioInputFilterSelectorItem[]
}

interface State {
    condition: string
    data: any
}

type BuilderData = BaseFilterSelectorBuilderData & CommonProps

type Filter = FilterSelector & CommonProps

type Props = FilterSelectorProps<State> & CommonProps

class AdvancedRadioInputFilterSelector extends Component<Props, State> {
    static create = (config: BuilderData): Filter => ({
        component: this,
        type: 'filter',
        getPillDisplayValue: ({ condition, data }: State): string => {
            const item = config.items.find((i) => i.value === condition)

            const value = Array.isArray(data) ? data.join(' and ') : data
            return `${item?.name} ${value}`
        },
        ...config
    })

    constructor(props: Props) {
        super(props)
        this.state = {
            condition: props.selectedFilterItems?.condition ?? '',
            data:
                typeof props.selectedFilterItems?.data !== 'undefined'
                    ? props.selectedFilterItems.data
                    : []
        }
    }

    setCondition = (condition: string) => {
        const { data } = this.state

        const isRange = condition === 'between'
        const fromRelative = !!data && Array.isArray(data) ? data?.[0] : data

        this.setState({ condition, data: isRange ? [data, ''] : fromRelative })
    }

    setData = (data: string) => {
        this.setState({ data })
    }

    setRangeData = (value: string, index: number) => {
        const { data } = this.state
        data[index] = value
        this.setState({ data })
    }

    render() {
        const { condition, data } = this.state
        const { id, name, items, children } = this.props

        return (
          <div>
            <div className='overview__filters-box-content'>
              {items.map((item) => {
                        const isChecked = condition === item.value
                        return (
                          <div key={item.id}>
                            <InputGroup
                              inline
                              qaClasses={`qa-filter-input-${item.value}`}
                              key={item.id}
                              name={name}
                              value={item.value}
                              title={item.name}
                              type='radio'
                              formGroupClasses='overview__filters-box-filter'
                              checked={isChecked}
                              onChange={(e) => this.setCondition(e.target.value)}
                            />
                            {isChecked && item.type === 'range' && (
                              <div className='qa-radio-filter-input-group'>
                                <InputGroup
                                  inline
                                  qaClasses='qa-radio-filter-input'
                                  name={name}
                                  value={data?.[0]}
                                  title='and'
                                  type='number'
                                  min={0}
                                  formGroupClasses='overview__filters-data-input'
                                  onKeyUp={(e) => this.setRangeData(e.target.value, 0)}
                                  onChange={(e) => this.setRangeData(e.target.value, 0)}
                                />
                                <InputGroup
                                  inline
                                  qaClasses='qa-radio-filter-input-right'
                                  name={name}
                                  value={data?.[1]}
                                  title={id}
                                  type='number'
                                  min={0}
                                  formGroupClasses='overview__filters-data-input'
                                  onKeyUp={(e) => this.setRangeData(e.target.value, 1)}
                                  onChange={(e) => this.setRangeData(e.target.value, 1)}
                                />
                              </div>
                                )}
                            {isChecked && item.type === 'relative' && (
                              <InputGroup
                                inline
                                qaClasses='qa-radio-filter-input'
                                name={name}
                                value={data}
                                title={item.id === 'between' ? 'and' : id}
                                type='number'
                                min={0}
                                formGroupClasses='overview__filters-data-input'
                                onKeyUp={(e) => this.setData(e.target.value)}
                                onChange={(e) => this.setData(e.target.value)}
                              />
                                )}
                          </div>
                        )
                    })}
            </div>
            {extractRenderPropsChildren(children)({
                    data: { ...this.state, data: data },
                    isApplyButtonDisabled: !condition || !data ||
                        (Array.isArray(data)
                            ? data.filter((item) => !!item).length < 2
                            : data.length === 0)
                })}
          </div>
        )
    }
}

export default AdvancedRadioInputFilterSelector
